import type { AtomForm, ObjectForm } from "@pdfking/forms"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { RecordCreate } from "@pdfking/tfunc"

import { range_for } from "../../controller/RangeFor"
import { IDMixin } from "../../mixins/IDMixin"
import { dom_id } from "../dispatch/DomId"
import { DjSelect } from "../fields/DjSelect"
import { FieldMixin } from "../mixins/FieldMixin"
import { AtomFormMixin } from "../mixins/FormMixin"
import { NodeMixin } from "../mixins/NodeMixin"

export const FileId = CreateRenderFunction({
  mixins: [NodeMixin, FieldMixin, IDMixin, AtomFormMixin] as const,

  render() {
    const choices = RecordCreate([["", "-"], ...this.ctx.file_options()])
    const row = this.parent as ObjectForm<Record<string, unknown>> | undefined
    return (
      <DjSelect
        choices={choices}
        disabled={this.disabled}
        error={this.node!.error}
        dom_id={dom_id(this)}
        input={this.node!.input}
        onselect={(value: string | string[]) => {
          this.node!.validate(value)
          const range = row?.results.file_range as AtomForm<unknown> | undefined
          range?.validate(
            value ? range_for(this.ctx.file_media[String(value)]?.page_count ?? 0) : ""
          )
        }}
      />
    )
  },
})
